export default class EnvUtils {
  static getEnv() {
    return process.env.NODE_ENV;
  }
}
